<template>
    <div class="d-flex flex-row">
        <btn-select :value.sync="relative" :options="relatives"></btn-select>
        <template v-if="relative!=='Now'">
            <b-form-input type="number" class="m-auto number" v-model="quantity" min="0"></b-form-input>
            <btn-select :value.sync="unit" :options="units"></btn-select>
        </template>
    </div>
</template>

<script>
import BtnSelect from "@/components/common/inputs/BtnSelect.vue";
import valueMixin from "@/components/common/inputs/mixin/value-mixin";

export default {
    name: "MiniRelativeDate",
    components: {BtnSelect},
    mixins: [valueMixin],
    props: {
        toJson: Boolean,
    },
    data() {
        return {
            relatives: ['Last', 'Now', 'Future'],
            units: ['Year', 'Quarter', 'Month', 'Week', 'Day', 'WorkDay'],
            relative: 'Last',
            quantity: 0,
            unit: 'Day'
        }
    },
    computed: {
        config() {
            return {
                relative: this.relative,
                quantity: this.quantity,
                unit: this.unit
            }
        },
    },
    watch: {
        config: {
            handler() {
                if (this.toJson) {
                    this.localValue = JSON.stringify(this.config);
                } else {
                    this.localValue = this.config;
                }
            },
            immediate: true,
        },
    },
    methods: {
        handleValue() {
            let temp = this.value;
            if (temp) {
                if (typeof temp === 'string') {
                    if (temp.startsWith('{')) {
                        temp = JSON.parse(temp);
                    } else {
                        return;
                    }
                }
                this.relative = temp.relative;
                this.quantity = temp.quantity || 0;
                this.unit = temp.unit || 'Day';
            }
        },
    }
}
</script>

<style scoped>
.number {
    font-weight: bold;
    font-size: 1rem;
    height: 100%;
    max-width: 60px;
}
</style>
